<template>
  <div class='number'>
    <div
      v-for='row in 6'
      v-bind:key='`r_${row}`'
      class='row'
    >
      <Clock
        v-for='col in 4'
        v-bind:key='`r_${row}_c_${col}`'
        ref='clocks'
      />
    </div>
  </div>
</template>

<script>
import Clock from './clock';

const NUMBERS_SPEC = [
  // 0
  [
    [ 3, 30], [ 3, 45], [ 3, 45], [ 9, 30],
    [12, 30], [ 3, 30], [ 9, 30], [12, 30],
    [12, 30], [12, 30], [12, 30], [12, 30],
    [12, 30], [12, 30], [12, 30], [12, 30],
    [12, 30], [12, 15], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 3, 45], [12, 45]
  ],
  // 1
  [
    [ 3,   30  ], [ 3, 45], [ 9, 30], [ 7.5, 37.5],
    [12,   15  ], [ 9, 30], [12, 30], [ 7.5, 37.5],
    [ 7.5, 37.5], [12, 30], [12, 30], [ 7.5, 37.5],
    [ 7.5, 37.5], [12, 30], [12, 30], [ 7.5, 37.5],
    [ 3,   30  ], [12, 45], [12, 15], [ 9,   30  ],
    [12,   15  ], [ 3, 45], [ 3, 45], [12,   45  ]
  ],
  // 2
  [
    [ 3, 30], [ 3, 45], [ 9, 15], [ 9, 30],
    [12, 15], [ 3, 45], [ 9, 30], [12, 30],
    [ 3, 30], [ 3, 45], [12, 45], [12, 30],
    [12, 30], [ 3, 30], [ 9, 15], [12, 45],
    [12, 30], [12, 15], [ 9, 15], [ 9, 30],
    [12, 15], [ 3, 45], [ 3, 45], [12, 45]
  ],
  // 3
  [
    [ 3, 30], [ 3, 45], [ 9, 15], [ 9, 30],
    [12, 15], [ 3, 45], [ 9, 30], [12, 30],
    [ 3, 30], [ 3, 45], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 9, 30], [12, 30],
    [ 3, 30], [ 9, 15], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 3, 45], [12, 45]
  ],
  // 4
  [
    [ 3,   30  ], [ 6,   45  ], [ 6, 15], [ 9, 30],
    [12,   30  ], [12,   30  ], [12, 30], [12, 30],
    [12,   30  ], [12,   15  ], [12, 45], [12, 30],
    [12,   15  ], [ 3,   45  ], [ 9, 30], [12, 30],
    [ 7.5, 37.5], [ 7.5, 37.5], [12, 30], [12, 30],
    [ 7.5, 37.5], [ 7.5, 37.5], [12, 15], [12, 45]
  ],
  // 5
  [
    [ 3, 30], [ 3, 45], [ 9, 15], [ 9, 30],
    [12, 30], [ 3, 30], [ 9, 15], [12, 45],
    [12, 30], [12, 15], [ 9, 15], [ 9, 30],
    [12, 15], [ 9, 15], [ 9, 30], [12, 30],
    [ 3, 30], [ 9, 15], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 3, 45], [12, 45]
  ],
  // 6
  [
    [ 3, 30], [ 3, 45], [ 9, 15], [ 9, 30],
    [12, 30], [ 3, 30], [ 9, 15], [12, 45],
    [12, 30], [12, 15], [ 9, 15], [ 9, 30],
    [12, 30], [ 3, 30], [ 9, 30], [12, 30],
    [12, 30], [12, 15], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 3, 45], [12, 45]
  ],
  // 7
  [
    [ 3,   30  ], [ 3, 45  ], [ 9, 15  ], [ 9,   30  ],
    [12,   15  ], [ 3, 45  ], [ 9, 37.5], [12,   37.5],
    [ 7.5, 37.5], [ 6,  7.5], [ 6,  7.5], [ 7.5, 37.5],
    [ 7.5, 37.5], [12, 30  ], [12, 30  ], [ 7.5, 37.5],
    [ 7.5, 37.5], [12, 30  ], [12, 30  ], [ 7.5, 37.5],
    [ 7.5, 37.5], [12, 15  ], [12, 45  ], [ 7.5, 37.5]
  ],
  // 8
  [
    [ 3, 30  ], [ 3, 45], [ 9, 15], [ 9, 30  ],
    [12, 30  ], [ 3, 30], [ 9, 30], [12, 30  ],
    [12, 22.5], [12, 15], [12, 45], [12, 37.5],
    [ 6,  7.5], [ 3, 30], [ 9, 30], [ 6, 52.5],
    [12, 30  ], [12, 15], [12, 45], [12, 30  ],
    [12, 15  ], [ 3, 45], [ 3, 45], [12, 45  ]
  ],
  // 9
  [
    [ 3, 30], [ 3, 45], [ 9, 15], [ 9, 30],
    [12, 30], [ 3, 30], [ 9, 30], [12, 30],
    [12, 30], [12, 15], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 9, 30], [12, 30],
    [ 3, 30], [ 9, 15], [12, 45], [12, 30],
    [12, 15], [ 3, 45], [ 3, 45], [12, 45]
  ],
]

export default {
  name: 'Number',
  components: {
    Clock
  },
  methods: {
    setValue: function(number) {
      const info = NUMBERS_SPEC[number];

      for (let i = 0; i < 24; ++i) {
        this.$refs.clocks[i].setTime(info[i][0], info[i][1]);
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .number {
    .row {
      display: flex;
      align-items: center;
    }
  }
</style>
